import fetch from './fetch';

const getUserMessage = () => fetch('current-user')
  .then((response) => response.json())
  .then((currentUser) => currentUser.message)
  .catch(() => ({}));

export default getUserMessage;
